import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      className="language-switcher"
      onClick={toggleLanguage}
      aria-label={`Switch to ${i18n.language === 'en' ? 'Arabic' : 'English'}`}
      title={`Switch to ${i18n.language === 'en' ? 'العربية' : 'English'}`}
    >
      <span className="language-switcher__text">
        {i18n.language === 'en' ? 'العربية' : 'EN'}
      </span>
      <span className="language-switcher__flag">
        {i18n.language === 'en' ? '🇸🇦' : '🇬🇧'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;